export function resolveEmailBuilderFacilityLogoSource(
  logoSource: string | null | undefined,
): string | null {
  if (logoSource == null) {
    return null;
  }

  const trimmed = logoSource.trim();

  return trimmed.length > 0 ? trimmed : null;
}
